import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import reportWebVitals from './reportWebVitals'
// Config
import appConfig from '../package.json'
// Context Providers
import { AuthProvider } from 'context/AuthContext'
// Router
import AppRoutes from './router/AppRoutes'
// Styles
import * as Styled from './styled'
import './index.css'

// Logging the app version number on the first load of the app.
console.log(`Embedded Reporting App v${appConfig.version} has been loaded.`)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <BrowserRouter>
        <Styled.NotificationProvider>
            <AuthProvider>
                <AppRoutes />
            </AuthProvider>
        </Styled.NotificationProvider>
    </BrowserRouter>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
